import React from 'react';
import { FormGroup, Input } from 'reactstrap';

import style from './input.module.scss';

const InputComponent = ({
  label,
  placeholder,
  name,
  type,
  value,
  onChange,
  accept,
  register,
  disabled,
  errorMessage
}) => {
  const { ref, ...sampleName } = register(name);
  return (
    <FormGroup>
      {label && <label className={`font-weight-bold`}>{label}</label>}
      <Input
        className={`${style.inputCommon}`}
        placeholder={placeholder}
        type={type || 'text'}
        name={name || ''}
        value={value && value}
        onChange={onChange && onChange}
        accept={accept}
        innerRef={ref}
        disabled={disabled}
        {...sampleName}
        style={{
          color: '#000'
        }}
      />
      {errorMessage && (
        <span className={style.errorMessage}>{errorMessage}</span>
      )}
    </FormGroup>
  );
};

export default InputComponent;
